import { gql } from "@apollo/client";

export const membershipValidate = gql`
  mutation membership_validate(
    $club_id: String!,
    $phone: String
  ) {
    membership_validate(
      club_id: $club_id,
      phone: $phone
      ) {
      result {
        success
        errors {
          code
          field
          message
        }
      }
    }
  }
`;
